export default __webpack_public_path__ + "4527db21773bb3dae98c9297d6a5404b.png";